import {SupportTrainingResult} from './SupportTrainingResultSchema';

export type SupportTrainingUseCaseResult = {
  result: SupportTrainingResult;
};
